import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import DashboardLayout from './DashboardLayout';

/**
 * Sidebar + header layout for all dashboard-style routes (public + gated).
 *
 * The inner `<Suspense>` keeps lazy-loaded children scoped to the content
 * area, so navigating between `/dashboard/*` routes never unmounts the
 * sidebar/header — only the main region shows the skeleton.
 */
const ContentSkeleton = () => (
    <div className="space-y-3 animate-pulse" aria-label="Loading">
        <div className="h-6 w-40 rounded bg-gray-200 dark:bg-gray-800" />
        <div className="h-4 w-64 rounded bg-gray-200 dark:bg-gray-800" />
        <div className="h-32 rounded bg-gray-200 dark:bg-gray-800" />
        <div className="h-32 rounded bg-gray-200 dark:bg-gray-800" />
    </div>
);

const DashboardShell = () => (
    <DashboardLayout>
        <Suspense fallback={<ContentSkeleton />}>
            <Outlet />
        </Suspense>
    </DashboardLayout>
);

export default DashboardShell;
